<template>
  <div class="layout-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "LayoutMain",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.layout-main {
  width: 100%;
  min-height: 500px;
  position: relative;
}
</style>
